import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Collapse,
  Box,
  IconButton,
  CircularProgress,
  ListItemText,
  Typography,
} from "@mui/material";
// import moment from "moment";
import { FC, Fragment, useContext, useState } from "react";
import AddProcedure from "./AddProcedure";
import { ProcedureContext } from ".";
import { ProcedureFormValueType, ProcedureTableType } from "./types";
// import { userTypes } from "../../../constants";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckIcon from "@mui/icons-material/Check";
import { Close } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useParams } from "react-router-dom";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import EmptyListAlert from "../layouts/EmptyListAlert";
// import LogComonent from "../layouts/LogComonent";
import useDeleteActivity from "../hook/useDeleteActivity";
import { EmrContext } from "../..";
import HistoryComponent from "../layouts/HistoryComponent";
const getStatusLabel = (procedureStatus: string | undefined, status: number | string): string => {
  if (procedureStatus) return procedureStatus;
  if (status === 1 || status === "1") return "PLANNED";
  if (status === 2 || status === "2") return "UNDERGOING";
  if (status === 3 || status === "3") return "COMPLETED";
  return "PLANNED";
};

const ProceduresList: FC = () => {
  const { encounterId, patientId } = useParams();
  const { list, edit, setEdit, refetch } = useContext(ProcedureContext);
  const { setTrigger } = useContext(HL7ContexTriggerContex);
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(-1);
  const { patientData } = useContext(EmrContext);

  const { mutate: deletedProce, isLoading: deleteLoading } = useDeleteActivity(
    (result) => {
      if (result.responseIndicator == "success") {
        refetch();
      }
    },
  );

  const handleDelete = (item: ProcedureTableType, index: number) => {
    if (item.isPerformed) {
      setTrigger({
        tab: "procedure",
        encounterId: encounterId as string,
      });
    }
    deletedProce({
      activityId: item.procedureId,
      cptGrpId: item.cptGroupId as number,
      encounterId: parseInt(encounterId as string),
      paymentMode: patientData?.pmaster?.paymentMode,
    });
    setSelected(index);
  };

  const handleClose = () => {
    setShow(false);
    setEdit(null);
  };

  const handleEdit = (value: ProcedureTableType) => {
    setShow(false);

    let Amount = patientData.pmaster.paymentMode
      ? value.isExcluded
        ? value.amount
        : value.insAmount || value.amount
      : value.amount;
    let PatientShare = patientData.pmaster.paymentMode
      ? value.isExcluded
        ? value.amount
        : value.pshare
      : value.amount;
    const updata: ProcedureFormValueType = {
      amount: Amount.toString(),
      cpt_code: {
        cptId: value.cptId as number,
        ins_ref_id: 0,
        cptCode: value.cptCode as string,
        insCoverage: value.insCoverage as number,
        cptName: value.cptName as string,
        cptGroupId: value?.cptGroupId || 0,
        cptRate: Number(value?.cptRate || 0),
      },
      encounterId: encounterId as string,
      isApprovalRequired: value.isApprovalRequired,
      procedureId: value.procedureId, // example property - ensure this is defined in `ProcedureTableType`
      rate: value.rate.toString(), // example property - use a default if necessary
      quantity: value.quantity.toString(), // example property - use a default if necessary
      pShare: PatientShare.toString(),
      isPerformed: value.procedureStatus == "COMPLETED" ? true : false,
      nursingProcedure: value.nursingProcedure,
      nursingRemarks: value.nursingRemarks,
      isExcluded: value.isExcluded,
      patientId: patientId as string,
      remarks: String(value.doctorsRemarks || value.remarks || ""),
      createdDate: value?.createdByDate,
      insuranceCoverage: Number(value?.insCoverage),
      discount: Number(value.discountAmount || value.discountPercentage || 0),
      discountType: String(value.discountType),
      procedureStatus: getStatusLabel(value.procedureStatus, value.status),
    };
    console.log("updata===>", value);
    setEdit({
      ...updata,
    });
  };
  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
          >
            {heading.map((heading, index) => (
              <TableCell
                sx={(theme) => ({
                  color: theme.palette.background.paper,
                  fontSize: "12px",
                })}
                align="left"
                key={`heading${index}`}
              >
                {heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
              <EmptyListAlert
                alert="No procedures"
                isData={Boolean(list?.length || show)}
                children={
                  !show && (
                    <div className="w-full flex justify-end items-center p-2 gap-3">
                      <Button
                        color="success"
                        endIcon={<AddCircleIcon />}
                        onClick={() => {
                          setShow(true);
                          setEdit(null);
                        }}
                      >
                        add
                      </Button>
                      <div>
                        {/* <LogComonent title="Procedure" field="procedure" /> */}
                        <HistoryComponent
                          logProps={{ title: "Procedure", field: "procedures" }}
                          title="Procedures"
                          tableprops={tableProps.slice(
                            0,
                            tableProps.length - 5,
                          )}
                        />
                      </div>
                    </div>
                  )
                }
              />
              <Collapse in={show} timeout="auto" unmountOnExit>
                <Box>
                  <AddProcedure close={handleClose} />
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
          {list?.map((row, index) => (
            <Fragment key={index}>
              <TableRow key={`allergy${index}`}>
                <TableCell>
                  {" "}
                  <ListItemText
                    primary={`${row?.cptCode} (${row?.cptName})`}
                    primaryTypographyProps={{ fontSize: ".8rem" }}
                    secondary={
                      row.isApprovalRequired && (
                        <Typography color="primary" fontSize={".7rem"}>
                          Approval required
                        </Typography>
                      )
                    }
                  ></ListItemText>
                </TableCell>
                <TableCell>{Number(row?.rate).toFixed(2)}</TableCell>
                <TableCell>{row?.quantity}</TableCell>
                <TableCell>
                  {row.discountAmount && `${row.discountAmount}`}
                  {row.discountPercentage && `${row.discountPercentage} %`}
                </TableCell>
                <TableCell>
                  {Number(
                    patientData.pmaster.paymentMode
                      ? row.isExcluded
                        ? row.amount
                        : row.insAmount || row.amount
                      : row.amount,
                  ).toFixed(2)}
                </TableCell>
                <TableCell>
                  {Number(row.pshare || 0).toFixed(2)}
                </TableCell>

                <TableCell sx={{ maxWidth: "600px" }}>
                  {String(row?.doctorsRemarks || "")}
                </TableCell>
                <TableCell>
                  <span
                    style={{
                      backgroundColor:
                        getStatusLabel(row?.procedureStatus, row?.status) === "COMPLETED"
                          ? "#dcfce7"
                          : getStatusLabel(row?.procedureStatus, row?.status) === "UNDERGOING"
                          ? "#fef9c3"
                          : "#e0f2fe",
                      color:
                        getStatusLabel(row?.procedureStatus, row?.status) === "COMPLETED"
                          ? "#15803d"
                          : getStatusLabel(row?.procedureStatus, row?.status) === "UNDERGOING"
                          ? "#a16207"
                          : "#1d4ed8",
                      padding: "4px 8px",
                      borderRadius: "12px",
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      display: "inline-block",
                    }}
                  >
                    {getStatusLabel(row?.procedureStatus, row?.status)}
                  </span>
                </TableCell>
                <TableCell>
                  {row?.isPerformed ? (
                    <CheckIcon color="primary" />
                  ) : (
                    <RemoveIcon />
                  )}
                </TableCell>
                <TableCell>
                  {row.isApprovalRequired ? (
                    <CheckIcon color="primary" />
                  ) : (
                    <RemoveIcon />
                  )}
                </TableCell>
                <TableCell>
                  {row.nursingProcedure ? (
                    <CheckIcon color="primary" />
                  ) : (
                    <RemoveIcon />
                  )}
                </TableCell>
                <TableCell>{row.nursingRemarks}</TableCell>
                {/* <TableCell>{userTypes[row.createdById]}</TableCell> */}
                <TableCell>
                  <div className="flex">
                    {edit?.procedureId == row.procedureId ? (
                      <IconButton
                        color="error"
                        onClick={() => {
                          setEdit(null);
                        }}
                      >
                        <Close />
                      </IconButton>
                    ) : (
                      <IconButton
                        color="primary"
                        onClick={() => {
                          handleEdit(row);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                    {deleteLoading && selected == index ? (
                      <CircularProgress
                        color="error"
                        sx={{ marginTop: "8px" }}
                        size={18}
                      />
                    ) : (
                      <IconButton
                        color="error"
                        onClick={() => {
                          handleDelete(row, index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                  <Collapse
                    in={Boolean(edit) && edit?.procedureId == row.procedureId}
                    timeout="auto"
                    unmountOnExit
                  >
                    <AddProcedure close={handleClose} />
                  </Collapse>
                </TableCell>
              </TableRow>
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProceduresList;
const heading = [
  "PROCEDURE",
  "UNIT RATE",
  "QUANTITY",
  "Discount",
  "AMOUNT",
  "PATIENT SHARE",
  "DOCTOR REMARKS",
  "STATUS",
  "IS PERFORMED",
  "APPROVAL REQUIRED",
  "NURSING PROCEDURE",
  "NURSING REMARKS",
  // "DONE BY",
  "OPTIONS",
];

const tableProps = [
  { heading: "CODE", key: "cptCode" },
  { heading: "UNIT RATE", key: "rate" },
  { heading: "QUANTITY", key: "quantity" },
  { heading: "AMOUNT", key: "amount" },
  { heading: "PATIENT SHARE", key: "pshare" },
  { heading: "DATE", key: "createdByDate", date: "DD-MM-YYYY" },
  { heading: "STATUS", key: "status" },
  { heading: "REMARKS", key: "remarks" },
  { heading: "IS PERFORMED", key: "isPerformed" },
  { heading: "APPROVAL REQUIRED", key: "isApprovalRequired" },
  { heading: "NURSING PROCEDURE", key: "nursingProcedure" },
  { heading: "NURSING REMARKS", key: "nursingRemarks" },
];
